<template>
    <div class="view__tabs">
        <ul class="view__tabs--menu">
            <li :class="getCssClass('account')">
                <router-link :to="{ name: 'account'}">
                    {{ L.localize('Account_Breadcrumb') }}
                </router-link>
            </li>
            <li :class="getCssClass(['users', 'user', 'user-create'])">
                <router-link :to="{ name: 'users'}">
                    {{ L.localize('Users_Breadcrumb_Index') }}
                </router-link>
            </li>
            <li :class="getCssClass('webhook')">
                <router-link :to="{ name: 'webhook'}">
                    {{ L.localize('Webhook_Breadcrumb_Index') }}
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import L from 'services/Localization'

export default {
  name: 'Submenu',
  data() {
    return {
      L: L
    }
  },
  methods: {
    getCssClass(name) {
      let baseClass = name.indexOf(this.$route.name) >= 0 ? 'active' : ''
      return `view__tabs--tab ${baseClass}`
    }
  }
}
</script>




// WEBPACK FOOTER //
// Submenu.vue?04c4f9b4